import Emitter from "@homer.core/emitter";
import StorageLocal from "@homer.core/storage.local";
import application from "@homer.core/application";
import { name } from "../package.json";

const storageLocal = new StorageLocal(name, { version: application.version, lifetime: 12 * 60 * 60 });
const events = JSON.parse(storageLocal.get() || "[]");
let persist = true;

class Bus extends Emitter {
    #private = {};

    constructor() {
        super();

        Object.defineProperties(this.#private, {
            on: {
                value: this.on.bind(this),
                enumerable: true,
            },
            off: {
                value: this.off.bind(this),
                enumerable: true,
            },
        });

        this.on(/.*/, (event, data) => {
            if (persist) {
                event.cancel();

                events.push({ name: event.name, data });
                storageLocal.set(JSON.stringify(events));
            }
        });
    }

    activate(...connector) {
        const now = +new Date();
        let event;

        persist = false;
        storageLocal.remove();

        connector.forEach((Connector) => {
            new Connector(this.#private);
        });

        while ((event = events.shift())) {
            this.emit(event.name, { ...event.data, queued: now - event.data.timestamp });
        }
    }
}

export default new Bus();
